import { createIcon } from '@chakra-ui/react'

export const CheckCircleOverlapIcon = createIcon({
  displayName: 'CheckCircleOverlapIcon',
  viewBox: '0 0 16 16',
  path: (
    <>
      <path d='M14.6673 7.38625V7.99958C14.6665 9.4372 14.201 10.836 13.3402 11.9875C12.4794 13.1389 11.2695 13.9812 9.89089 14.3889C8.51227 14.7965 7.03882 14.7475 5.6903 14.2493C4.34177 13.7511 3.19042 12.8303 2.40796 11.6243C1.6255 10.4183 1.25385 8.99163 1.34844 7.55713C1.44303 6.12263 1.99879 4.75714 2.93284 3.6643C3.86689 2.57146 5.12917 1.80984 6.53144 1.49301C7.93371 1.17619 9.40083 1.32114 10.714 1.90625' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' fill='transparent' />
      <path d='M14.6667 2.66699L8 9.34033L6 7.34033' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' fill='transparent' />
    </>
  ),
})
